import { HubFrameworkConfig } from '@/types/hub'

export const HUB_FRAMEWORKS: Record<string, HubFrameworkConfig> = {
  cmmc: {
    name: 'CMMC',
    slug: 'cmmc',
    hubDocumentType: 'compliance_cmmc_hub',
    articleDocumentType: 'compliance_cmmc_hub_aritcle',
    chapterDocumentType: 'compliance_cmmc_hub_chapter',
    hasCustomUrlHandling: true,
    chapters: [
      'overview',
      'news',
      'federal-compliance',
      'requirements',
      'certification',
      'automation',
      'resources',
      'enforcement',
    ],
    metadataExtractor: 'prismic',
    contentField: 'slices',
  },
  fedramp: {
    name: 'FedRAMP',
    slug: 'fedramp',
    hubDocumentType: 'compliance_fedramp_hub',
    articleDocumentType: 'compliance_fedramp_hub_article',
    chapterDocumentType: 'compliance_fedramp_hub_chapter',
    hasCustomUrlHandling: true,
    chapters: ['overview', 'levels', 'requirements', 'authorization', 'pmo_marketplace', 'resources'],
    metadataExtractor: 'prismic',
    contentField: 'slices',
  },
  'nist-800-53': {
    name: 'NIST 800-53',
    slug: 'nist-800-53',
    hubDocumentType: 'compliance_nist_800_53_hub',
    articleDocumentType: 'compliance_nist_800_53_hub_article',
    chapterDocumentType: 'compliance_nist_800_53_hub_chapter',
    hasCustomUrlHandling: true,
    chapters: ['overview', 'and-fisma', 'requirements', 'compliance', 'automation', 'resources'],
    metadataExtractor: 'prismic',
    contentField: 'slices',
  },
  cui: {
    name: 'CUI',
    slug: 'cui',
    hubDocumentType: 'compliance_cui_hub',
    articleDocumentType: 'compliance_cui_hub_article',
    chapterDocumentType: 'compliance_cui_hub_chapter',
    hasCustomUrlHandling: true,
    chapters: ['overview', 'categories', 'handling', 'scoping', 'compliance', 'enclaves'],
    metadataExtractor: 'prismic',
    contentField: 'slices',
  },
  gdpr: {
    name: 'GDPR',
    slug: 'gdpr',
    hubDocumentType: 'compliance_gdpr_hub',
    articleDocumentType: 'compliance_gdpr_hub_article',
    chapterDocumentType: 'compliance_gdpr_hub_chapter',
    hasCustomUrlHandling: false,
    chapters: ['overview', 'report', 'audit', 'preparation', 'automation', 'resources'],
    metadataExtractor: 'array',
    contentField: 'body',
  },
  hipaa: {
    name: 'HIPAA',
    slug: 'hipaa',
    hubDocumentType: 'compliance_hipaa_hub',
    articleDocumentType: 'compliance_hipaa_hub_article',
    chapterDocumentType: 'compliance_hipaa_hub_chapter',
    hasCustomUrlHandling: false,
    chapters: ['overview', 'rules-and-requirements', 'compliance', 'penalties', 'automation', 'resources'],
    metadataExtractor: 'array',
    contentField: 'body',
  },
  'iso-27001': {
    name: 'ISO 27001',
    slug: 'iso-27001',
    hubDocumentType: 'compliance_iso_27001_hub',
    articleDocumentType: 'compliance_iso_27001_hub_article',
    chapterDocumentType: 'compliance_iso_27001_hub_chapter',
    hasCustomUrlHandling: false,
    chapters: ['iso-27001-overview', 'report', 'audit', 'preparation', 'automation', 'resources'],
    metadataExtractor: 'array',
    contentField: 'body',
  },
  'pci-dss': {
    name: 'PCI DSS',
    slug: 'pci-dss',
    hubDocumentType: 'compliance_pci_dss_hub',
    articleDocumentType: 'compliance_pci_dss_hub_article',
    chapterDocumentType: 'compliance_pci_dss_hub_chapter',
    hasCustomUrlHandling: false,
    chapters: ['overview', 'report', 'audit', 'preparation', 'automation', 'resources'],
    metadataExtractor: 'array',
    contentField: 'body',
  },
  grc: {
    name: 'GRC',
    slug: 'grc',
    hubDocumentType: 'compliance_grc_hub',
    articleDocumentType: 'compliance_grc_hub_article',
    chapterDocumentType: 'compliance_grc_hub_chapter',
    hasCustomUrlHandling: false,
    chapters: ['overview', 'governance', 'risk', 'auditing', 'program', 'grc-automation'],
    metadataExtractor: 'array',
    contentField: 'body',
  },
  'soc-2': {
    name: 'SOC 2',
    slug: 'soc-2',
    hubDocumentType: 'compliance_hub', // Note: SOC-2 uses different naming
    articleDocumentType: 'soc_hub_article',
    chapterDocumentType: 'soc_hub_chapter',
    hasCustomUrlHandling: false,
    chapters: ['overview', 'report', 'audit', 'preparation', 'automation', 'resources'],
    metadataExtractor: 'array',
    contentField: 'body',
  },
}

export const FRAMEWORKS_WITH_CUSTOM_URLS = ['cmmc', 'nist-800-53', 'fedramp', 'cui']

export const DEFAULT_PROCESS_LEVELS = ['beginner', 'intermediate', 'advanced']

export const PRISMIC_PAGE_SIZE = 100

// Number of articles to pre-render per language for hub pages during static generation
export const PRE_RENDER_ARTICLES_LIMIT = 50

export const DEFAULT_HUB_LOCALE = 'en-us'
